import { values } from 'lodash-es';
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { serverUrl } from '../global/Environment';
import { logout } from '../services/authService';
import history from '../keeperHistory';

const baseUrl = serverUrl();

export const TAGS = {
  BOOKKEEPERS: 'BOOKKEEPERS',
  ESCALATION_ERRORS: 'ESCALATION_ERRORS',
  QDECK_USERS: 'QDECK_USERS',
  STAGE_COUNTS: 'STAGE_COUNTS',
  SUBSTAGE_COUNTS: 'SUBSTAGE_COUNTS',
  TASK_DETAIL_AVAILABLE_TAX_RETURNS: 'TASK_DETAIL_AVAILABLE_TAX_RETURNS',
  TASK: 'TASK',
  TASK_COMMENTS: 'TASK_COMMENTS',
  TASK_ACTIVITIES: 'TASK_ACTIVITIES',
  TASK_FORMS: 'TASK_FORMS',
  ASK_LOG: 'ASK_LOG',
  USER_ESCALATION_ERRORS: 'USER_ESCALATION_ERRORS',
  TASK_LIST: 'TASK_LIST'
};

const QUERY_MAX_RETRIES = 0;

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}api`,
  prepareHeaders: (headers) => {
    headers.set('Authorization', localStorage.getItem('KeeperToken'));
    // Headers to prevent return of cached data
    headers.set('Cache-Control', 'no-store');
    headers.set('Pragma', 'no-cache');
    headers.set('Expires', '0');
  },
  timeout: 10_000
});

const isUnauthorized = (response) => response?.data?.msg === 'Unauthorized Request';

const baseQueryWithRetry = retry(
  async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (isUnauthorized(result)) {
      api.dispatch(logout());
      history.push('/');
      retry.fail(result.error, result.meta);
    }

    return result;
  },
  {
    maxRetries: QUERY_MAX_RETRIES
  }
);

const baseApi = createApi({
  refetchOnReconnect: true,
  refetchOnFocus: true,
  // Keep unused query data for 3 mins (this is how long cached query state is valid after removal of all subscriptions)
  keepUnusedDataFor: 3 * 60,
  baseQuery: baseQueryWithRetry,
  tagTypes: values(TAGS),
  endpoints: () => ({})
});

export default baseApi;
